const headerWrapper = document.getElementById("HeaderWrapper");
const header = document.getElementById("shopify-section-header");
const body = document.getElementById("MainContent");
const overlay = document.querySelector(".header__overlay");
const tabButton = document.querySelectorAll(".tabs__button");
const contents = document.querySelectorAll(".tabs__content");
const mobileMenuIcon = document.querySelector(".header__mobile--open");
const mobileMenuButtons = document.querySelectorAll(".mobile__main__menu__link");
const mobileMenuMainContent = document.querySelector(".header__mobile__main");
const mobileSubMenus = document.querySelectorAll(".mobile__dropdown__menu__link");
const backToMainMenuButtons = document.querySelectorAll(".mobile__dropdown__wrapper--back");
const closeMobileMenuButtons = document.querySelectorAll(".header__mobile--close");
const openRightDrawer = document.querySelectorAll(".open__right__drawer");
const closeRightDrawer = document.querySelectorAll(".right__drawer--close");
const rightDrawerTogglers = document.querySelectorAll("[data-right-drawer-toggle]");
const rightDrawerRenderers = document.querySelectorAll("[data-right-drawer-renderer]");

function setOpenDrawerListeners(button) {
  button.addEventListener("click", function(e) {
  const rightDrawerTargetType = e.currentTarget.dataset.rightDrawerRenderer;
  if (!button.hasAttribute("data-right-drawer-renderer") ||
    ((window.location.href.indexOf("account") > -1) && rightDrawerTargetType == "account-actions"))
    return
  e.preventDefault();
  renderRightDrawerType(rightDrawerTargetType);
  document.body.classList.add("right__drawer--active");
  document.body.classList.add("no-scroll");
  });
}

function renderRightDrawerType(targetType) {
  const rendererTargetContainer = document.querySelector(`[data-right-drawer-type="${targetType}"]`);
  activeDrawerContent = document.querySelector(".right__drawer__content--active");
  if (activeDrawerContent)
    activeDrawerContent.classList.remove("right__drawer__content--active");
  rendererTargetContainer.getElementsByClassName("right__drawer__content")[0].classList.add("right__drawer__content--active");
}

openRightDrawer.forEach((button) => {
  setOpenDrawerListeners(button);
});

closeRightDrawer.forEach((button) => {
  button.addEventListener("click", function (e) {
    document.body.classList.remove("right__drawer--active");
    document.body.classList.remove("no-scroll");
  });
});

rightDrawerTogglers.forEach((button) => {
  button.addEventListener("click", function (e) {
    const togglerTarget = e.currentTarget.dataset.rightDrawerToggle;
    const togglerTargetContainer = document.querySelector(`[data-right-drawer-content="${togglerTarget}"]`);
    if (! togglerTargetContainer) return;
    document.querySelector(".right__drawer__content--active").classList.remove("right__drawer__content--active");
    togglerTargetContainer.classList.add("right__drawer__content--active");
  });
});
document.addEventListener(`Instructions::updated`, (e) => {
  const els = document.querySelectorAll("[data-right-drawer-toggle]");
  els.forEach((button) => {
    button.addEventListener("click", function (e) {
      const togglerTarget = e.currentTarget.dataset.rightDrawerToggle;
      const togglerTargetContainer = document.querySelector(`[data-right-drawer-content="${togglerTarget}"]`);
      if (! togglerTargetContainer) 
        return;
      
      document.querySelector(".right__drawer__content--active").classList.remove("right__drawer__content--active");
      togglerTargetContainer.classList.add("right__drawer__content--active");
    });
  });
});